import {useMemo} from "react";
import {ORDER_INVOICE_ISSUING_TYPE, INVOICE_CARRIER_TYPE} from '@Constants/';
import {isEqual} from '@Util/utils';

/**
 * 發票欄位顯示邏輯管理 Hook
 * @param {Object} params - 參數物件
 * @param {number} params.issuingType - 發票開立類型
 * @param {number} params.invoiceCarrierType - 發票載具類型
 * @param {boolean} params.readOnly - 是否為唯讀模式
 * @returns {Object} 欄位顯示狀態物件
 */
export const useInvoiceFieldVisibility = ({
                                              issuingType,
                                              invoiceCarrierType,
                                          }) => {
    return useMemo(() => {
        // 基本發票類型判斷
        const isDonateInvoice = isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.DONATE);
        const isDuplicateInvoice = isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.DUPLICATEUNIFORMINVOICE);
        const isTriplicateInvoice = isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.TRIPLICATEUNIFORMINVOICE);
        const isManualInvoice = isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.MANUAL);

        // 載具類型判斷
        const isMemberCarrier = isEqual(invoiceCarrierType, INVOICE_CARRIER_TYPE.MEMBERCARRIER);
        const isMobileBarcodeCarrier = isEqual(invoiceCarrierType, INVOICE_CARRIER_TYPE.MOBILEBARCODE);
        const isCitizenDigitalCarrier = isEqual(invoiceCarrierType, INVOICE_CARRIER_TYPE.CITIZENDIGITALCERTIFICATE);

        return {
            // 發票類型相關欄位
            showDonateField: isDonateInvoice,
            showTriplicateUniformField: isTriplicateInvoice,
            showManualInvoiceField: isManualInvoice,

            // 載具相關欄位
            showCarrierNoField: isDuplicateInvoice && !isMemberCarrier,
            showCarrierTypeField: isDuplicateInvoice,

            // 統一編號與發票抬頭（三聯式發票）
            showTaxIdField: isTriplicateInvoice,
            showTaxTitleField: isTriplicateInvoice,

            // 發票備註（所有類型都可能需要）
            showInvoiceNotesField: true,

            // 同步更新會員資訊（二聯式發票且有載具時）
            showSynchronizeMemberField: isDuplicateInvoice && invoiceCarrierType,

            // 便利方法：檢查是否為特定發票類型
            isDonateInvoice,
            isDuplicateInvoice,
            isTriplicateInvoice,
            isManualInvoice,

            // 便利方法：檢查是否為特定載具類型
            isMemberCarrier,
            isMobileBarcodeCarrier,
            isCitizenDigitalCarrier,
        };
    }, [issuingType, invoiceCarrierType]);
};

export default useInvoiceFieldVisibility;
